import { getGlobalFontFaceCss } from '../components/GlobalFonts/GlobalFonts';
import { normalizeCSS } from '../normalize';
import { theme } from '../theme.css';

/**
 * Manually injects Sparky baseline styles (Normalized CSS and Font-faces) into a Shadow Root.
 * This is required because global styles do not penetrate Shadow DOM boundaries.
 *
 * @param shadowRoot - The Shadow Root to inject styles into.
 */
export function injectSparkyStyles(shadowRoot: ShadowRoot) {
  // 1. Inject Fonts
  if (!shadowRoot.querySelector('#sparky-shadow-fonts')) {
    const fontStyle = document.createElement('style');
    fontStyle.id = 'sparky-shadow-fonts';
    fontStyle.textContent = getGlobalFontFaceCss();
    shadowRoot.appendChild(fontStyle);
  }

  // 2. Inject Normalized Baseline / Resets
  if (!shadowRoot.querySelector('#sparky-shadow-resets')) {
    const resetStyle = document.createElement('style');
    resetStyle.id = 'sparky-shadow-resets';

    const normalizeContent = Object.entries(normalizeCSS)
      .map(([selector, styles]) => {
        const rules = Object.entries(styles as Record<string, string>)
          .map(([prop, val]) => {
            const kebabProp = prop.replace(/([A-Z])/g, '-$1').toLowerCase();
            return `  ${kebabProp}: ${val};`;
          })
          .join('\n');
        return `${selector} {\n${rules}\n}`;
      })
      .join('\n\n');

    resetStyle.textContent = `
${normalizeContent}

/* Baseline host styling */
:host {
  display: block;
  font-family: ${theme.fonts.body};
  line-height: ${theme.lineHeights['6']};
  font-size: 62.5%; /* BASE_FONT_RELATIVE used across eneco frontend */
}
`;
    shadowRoot.appendChild(resetStyle);
  }

  // 3. Inject shared Sparky component styles if available globally
  // This supports the Chatbot's IIFE bundling strategy
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const globalSparkyCss = (window as any).__SPARKY_CSS__;

  if (globalSparkyCss && !shadowRoot.querySelector('#sparky-shadow-components')) {
    const componentStyle = document.createElement('style');
    componentStyle.id = 'sparky-shadow-components';
    componentStyle.textContent = globalSparkyCss;
    shadowRoot.appendChild(componentStyle);
  }
}
